// export DsfDataPanelPrimary from "./primary.vue";
// export DsfDataPanelDiscrete from "./discrete.vue";
// export DsfDataPanelGroup from "./primaryGroup.vue";
// export DsfDataPanelOne from "./one.vue";
// export DsfDataPanelTwo from "./two.vue";

export const DsfDataPanelPrimary = dsf.defineAsyncComponent("DsfDataPanelPrimary", () =>
  import(/*webpackChunkName:"platform_pc_homepage"*/ "./primary")
);
export const DsfDataPanelDiscrete = dsf.defineAsyncComponent("DsfDataPanelDiscrete", () =>
  import(/*webpackChunkName:"platform_pc_homepage"*/ "./discrete")
);
export const DsfDataPanelGroup = dsf.defineAsyncComponent("DsfDataPanelGroup", () =>
  import(/*webpackChunkName:"platform_pc_homepage"*/ "./primaryGroup")
);
export const DsfDataPanelOne = dsf.defineAsyncComponent("DsfDataPanelOne", () =>
  import(/*webpackChunkName:"platform_pc_homepage"*/ "./one")
);
export const DsfDataPanelTwo = dsf.defineAsyncComponent("DsfDataPanelTwo", () =>
  import(/*webpackChunkName:"platform_pc_homepage"*/ "./two")
);
